import React from 'react';
import { CogIcon } from '../icons/Icons'; 
import NotificationBell from '../../hooks/NotificationBell';

// Assuming Brand_logo.png is in the /public folder
const BRAND_LOGO_URL = '/Brand_logo.png';

/**
 * Navigation bar component.
 */
export default function Navbar({ appId, user, setView, currentView, userProfile, onSignOut, onOpenMyProfile }) {

    return (
        <header className="bg-white shadow-sm sticky top-0 z-50 print:hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    
                    {/* LEFT SIDE: LOGO */}
                    <button onClick={() => setView('home')} className="group flex-shrink-0 flex items-center space-x-2 cursor-pointer">
                         <img src={BRAND_LOGO_URL} alt="LINC Education Logo" className="h-8 sm:h-10 w-auto object-contain"/>
                         <span className="text-sm font-medium text-gray-500 group-hover:text-[#20BEC6] transition hidden sm:block">Home</span>
                    </button>
                    
                    {/* RIGHT SIDE: ACTIONS */}
                    <div className="flex items-center space-x-2 sm:space-x-4">
                        
                        {/* 1. USER PROFILE TRIGGER (Responsive) */}
                        {userProfile && (
                            <button 
                                onClick={onOpenMyProfile} 
                                className="flex items-center space-x-2 focus:outline-none group" 
                                title="View Profile"
                            >
                                {/* A. Avatar: Visible on ALL screens */}
                                <img 
                                    src={userProfile.photoURL || `https://ui-avatars.com/api/?name=${userProfile.name}&background=random`} 
                                    alt={userProfile.name}
                                    referrerPolicy="no-referrer"
                                    className="h-8 w-8 rounded-full object-cover border border-gray-200 group-hover:border-[#20BEC6] transition"
                                />
                                
                                {/* B. Name: Hidden on Mobile, Visible on Desktop */}
                                <span className="text-sm text-gray-600 font-medium hidden md:block group-hover:text-[#20BEC6] transition">
                                    {userProfile.name}
                                </span>
                            </button>
                        )}

                        {/* 2. ADMIN SETTINGS */}
                        {userProfile?.role === 'Admin' && (
                            <button onClick={() => setView('admin')} className="p-2 text-gray-500 hover:text-[#20BEC6] transition" title="Admin Settings">
                                <CogIcon className="h-6 w-6" />
                            </button>
                        )}
			{/* --- NEW: NOTIFICATION BELL --- */}
                        {userProfile && appId && (
                            <NotificationBell 
                                appId={appId} 
                                userProfile={userProfile} 
                                setView={setView} // Passing setView to handle clicks
                            />
                        )}
                        {/* 3. SIGN OUT */}
                        <button 
                            onClick={onSignOut} 
                            className="px-3 py-1.5 text-xs sm:text-sm bg-red-500 text-white rounded-md hover:bg-red-600 transition shadow-sm"
                        >
                            Sign Out
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
}